import React from 'react';

import { ReactComponent as AmericanExpressWalletIcon } from 'assets/icons/AmericanExpressWalletIcon.svg';
import { ReactComponent as ApplePayWalletIcon } from 'assets/icons/ApplePayWalletIcon.svg';
import { ReactComponent as DefaultWalletIcon } from 'assets/icons/DefaultWalletIcon.svg';
import { ReactComponent as GooglePayWalletIcon } from 'assets/icons/GooglePayWalletIcon.svg';
import { ReactComponent as MastercardWalletIcon } from 'assets/icons/MastercardWalletIcon.svg';
import { ReactComponent as VisaWalletIcon } from 'assets/icons/VisaWalletIcon.svg';

import { IPaymentMethodsType, PAYMENT_METHODS } from 'interfaces/payments';

import { IPaymentIconProps } from './types';

type PaymentMethodIcons = {
  [key in IPaymentMethodsType]: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | null;
};

const paymentMethodIcons: PaymentMethodIcons = {
  [PAYMENT_METHODS.VISA]: VisaWalletIcon,
  [PAYMENT_METHODS.MASTERCARD]: MastercardWalletIcon,
  [PAYMENT_METHODS.AMERICAN_EXPRESS]: AmericanExpressWalletIcon,
  [PAYMENT_METHODS.APPLE_PAY]: ApplePayWalletIcon,
  [PAYMENT_METHODS.GOOGLE_PAY]: GooglePayWalletIcon,
};

export const PaymentIcon: React.FC<IPaymentIconProps> = ({ walletType }) => {
  const IconComponent = paymentMethodIcons[walletType] || DefaultWalletIcon;

  return <IconComponent />;
};
